import { ApolloProvider } from "@apollo/client";
import { clientNeoAuth } from "@neonumy/api-clients";
import * as Sentry from "@sentry/browser";
import { createRoot } from "react-dom/client";
import { hotjar } from "react-hotjar";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

const CI_COMMIT_SHORT_SHA = import.meta.env.VITE_CI_COMMIT_SHORT_SHA;

// After a new deploy, chunk hashes change and lazy imports of stale chunks
// fail (the server falls back to index.html). Reload once to fetch the new build.
window.addEventListener("vite:preloadError", event => {
  event.preventDefault();
  const reloadKey = "vite-preload-error-reload";
  if (sessionStorage.getItem(reloadKey) !== CI_COMMIT_SHORT_SHA) {
    sessionStorage.setItem(reloadKey, CI_COMMIT_SHORT_SHA);
    window.location.reload();
  }
});

if (import.meta.env.PROD && import.meta.env.VITE_HOTJAR) {
  hotjar.initialize({
    id: Number(import.meta.env.VITE_HOTJAR),
    sv: 6,
  });
}

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_ENV || "development",
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "TypeError: NetworkError when attempting to fetch resource.",
      "Failed to fetch",
      "Invalid Token",
    ],
    release: CI_COMMIT_SHORT_SHA,
  });
  Sentry.setTag("CI_COMMIT_SHORT_SHA", CI_COMMIT_SHORT_SHA);
}

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <ApolloProvider client={clientNeoAuth}>
    <App />
  </ApolloProvider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
